import PropTypes from 'prop-types';
import React, { PureComponent, Fragment } from 'react';
import Avatar from '@material-ui/core/Avatar';
import CardActions from '@material-ui/core/CardActions';
import CardHeader from '@material-ui/core/CardHeader';
import CloseIcon from '@material-ui/icons/Close';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';

// https://stackoverflow.com/questions/13627308/add-st-nd-rd-and-th-ordinal-suffix-to-a-number
const ordinalSuffixOf = (i) => {
  const j = i % 10;
  const k = i % 100;
  if (j === 1 && k !== 11) {
    return `${i}st`;
  }
  if (j === 2 && k !== 12) {
    return `${i}nd`;
  }
  if (j === 3 && k !== 13) {
    return `${i}rd`;
  }
  return `${i}th`;
};

const styles = (theme) => ({
  avatar: {
    top: -theme.spacing.unit,
  },
  bold: {
    fontWeight: 800,
  },
  cardSubheader: {
    color: 'gray',
  },
  closeIcon: {
    position: 'absolute',
    right: '6px',
    top: '6px',
    color: '#2C2C2C',
    height: '16px',
  },
  header: {
    paddingBottom: 0,
    marginTop: '-20px',
    paddingRight: '10px',
  },
  overline: {
    letterSpacing: 1,
    opacity: 0.5,
    marginBottom: theme.spacing.unit,
  },
  title: {
    fontWeight: 'bold',
    lineHeight: 1.3,
  },
});

class TriviaLeaderboardHeaderComponent extends PureComponent {
  static propTypes = {
    classes: PropTypes.objectOf(PropTypes.string).isRequired,
    myAvatar: PropTypes.string,
    myPosition: PropTypes.number,
    myScore: PropTypes.number,
    onClose: PropTypes.func.isRequired,
  };

  static defaultProps = {
    myAvatar: '',
    myPosition: -1,
    myScore: 0,
  };

  render() {
    const { classes, myAvatar, myPosition, myScore, onClose } = this.props;
    return (
      <Fragment>
        <CardActions>
          <CloseIcon onClick={onClose} className={classes.closeIcon} />
        </CardActions>
        <CardHeader
          className={classes.header}
          classes={{ subheader: classes.cardSubheader }}
          avatar={<Avatar aria-label="Avatar" className={classes.avatar} src={myAvatar} />}
          title={
            <Typography variant="h6" className={classes.title}>
              You finished in the {ordinalSuffixOf(myPosition)} place!
            </Typography>
          }
          subheader={
            <Typography variant="overline" className={classNames(classes.overline, classes.title)}>
              {myScore} PTS
            </Typography>
          }
        />
        <Divider inset />
      </Fragment>
    );
  }
}

export const TriviaLeaderboardHeader = withStyles(styles)(TriviaLeaderboardHeaderComponent);
